<template>
  <van-row class="item van-hairline--surround"
           @click="selectChat"
  >
    <div class="msg_content">
      <van-image
              round
              width="1.3rem"
              height="1.3rem"
              :src="item.userProfile.avatar"
              class="avatar"
      />
      <div class="content">
        <p class="nick substring">{{item.userProfile.nick || item.userProfile.userID}}</p>
        <div class="desc substring" :title="item.lastMessage.messageForShow">
          {{messageForShow}}
        </div>
      </div>
    </div>
    <div class="right-content">
      <span class="time">{{date}}</span>
      <van-badge class="count" :content="item.unreadCount" max="99" v-if="showUnreadCount" />
    </div>
  </van-row>
</template>

<script>
import {getDate, getTime, isToday} from '@/utils/date'
import { mapState,mapGetters } from 'vuex'
export default {
  name: 'chatTingItem',
  props: ['item'],
  computed:{
    ...mapState({
      currentConversation: state => state.conversation.currentConversation,
      currentUserProfile: state => state.user.currentUserProfile,
      userID:state=>state.user.userID,
    }),
    ...mapGetters('conversation',['toAccount']),
    date() {
      if (
          !this.item.lastMessage ||
          !this.item.lastMessage.lastTime
      ) {
        return ''
      }
      const date = new Date(this.item.lastMessage.lastTime * 1000)
      if (isToday(date)) {
        return getTime(date)
      }
      return getDate(date)
    },
    showUnreadCount() {
      if (this.$store.getters.hidden) {
        return this.item.unreadCount > 0
      }
      // 是否显示未读计数。当前会话和未读计数为0的会话，不显示。
      return (
          this.currentConversation.conversationID !==
          this.item.conversationID && this.item.unreadCount > 0
      )
    },
    messageForShow() {
      if (this.item.lastMessage.isRevoked) {
        if (this.item.lastMessage.fromAccount === this.currentUserProfile.userID) {
          return '你撤回了一条消息'
        }
        if (this.item.type === this.TIM.TYPES.CONV_C2C) {
          return '对方撤回了一条消息'
        }
        return `${this.item.lastMessage.fromAccount}撤回了一条消息`
      }
      if (this.item.lastMessage.type===this.TIM.TYPES.MSG_CUSTOM) {
        if (this.item.lastMessage.payload.extension === 'jobs') {
          if (this.item.lastMessage.payload.description) {
            return this.item.lastMessage.payload.description+'的职位消息'
          }
          return '[职位消息]'
        }
        if (this.item.lastMessage.payload.extension === 'resumes') {
          if (this.item.lastMessage.payload.description) {
            return this.item.lastMessage.payload.description+'的简历消息'
          }
          return '[简历消息]'
        }
        if (this.item.lastMessage.payload.extension === 'get_resumes') {
          return '[查看简历]'
        }
        if (this.item.lastMessage.payload.extension==='phone') {
          return '[手机号码]'
        }
        if (this.item.lastMessage.payload.extension==='end_chat'){
          return '[结束洽谈]'
        }
        if (this.item.lastMessage.payload.extension==='overtime'){
          return '[沟通超时]'
        }
      }
      return this.item.lastMessage.messageForShow
    },
  },
  mounted() {
  },
  methods:{
    selectChat() {
      this.$router.push({ name: 'chats', query: { userId: this.item.userProfile.userID } })
    }
  },
}
</script>

<style lang="stylus" scoped>
.avatar{
  margin-right: 0.3rem;
  display: inline-block;
}
.item{
  min-height: 2rem;
  border-bottom: 1px solid #D9D9D9;
  width: 100%;
  padding: 0.5rem;
  font-size: 1.08rem;
}
.msg_content{
  display: flex;
  align-items: center;
}
.content{
  max-width: 80%;
  min-width: 70%;
  p{
    margin: 0;
  }
  .nick{
    font-size: 0.36rem
  }
  .desc{
    font-size: 0.30rem;
    color: #999;
    line-height: .5rem;
  }
}
.right-content{
  font-size: 0.96rem;
  color: inherit;
  height:.3rem;
  .time{
    top: .1rem;
    right: 0;
    color: #999999;
    font-size: 0.28rem;
    display: inline-block;
    position: absolute;
    margin-right: 0;
  }
  .count{top: -1.4rem;
    right: -.2rem;
    display: inline-block;
    position: absolute;
  }
}
</style>
